// extracted by mini-css-extract-plugin
export var container = "_h6-0";
export var content = "_h6-3";
export var customerTitle = "_h6-4";
export var empty = "_h6-5";
export var gray = "_h6-6";
export var header = "_h6-7";
export var info = "_h6-8";
export var loading = "_h6-2";
export var loadingCard = "_h6-9";
export var oneLine = "_h6-a";
export var personName = "_h6-e";
export var pillContainer = "_h6-b";
export var selected = "_h6-1";
export var text = "_h6-c";
export var twoLines = "_h6-d";
export var unread = "_h6-f";
export var unreadIndicator = "_h6-g";